// Basic popup

import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import IntlMessages from 'Util/IntlMessages';
import CloseIcon from '@mui/icons-material/Close';
import { closeCommonPopup } from 'Actions';
import exclamation from 'Assets/img/ic_exclamation.png';
import exclamation2 from 'Assets/img/ic_exclamation@2x.png';
import exclamation3 from 'Assets/img/ic_exclamation@3x.png';
import success from 'Assets/img/ic_success.png';
import success2 from 'Assets/img/ic_success@2x.png';
import success3 from 'Assets/img/ic_success@3x.png';
import warning from 'Assets/img/ic_warning_red.png';
import warning2 from 'Assets/img/ic_warning_red@2x.png';
import warning3 from 'Assets/img/ic_warning_red@3x.png';

import { connect } from 'react-redux';

const exImages = [exclamation, exclamation2, exclamation3];
const suImages = [success, success2, success3];
const waImages = [warning, warning2, warning3];
class CommonPopup extends Component {
  static defaultProps = {
    clickableBg: true,
    needIntl: true,
    size: 'sm',
    centered: true,
    needHeader: false,
    imageType: '',
    isReverse: false,
    isBigPadding: false,
  };
  constructor(props) {
    super(props);
    this._onClose = this._onClose.bind(this);
    this._onConfirm = this._onConfirm.bind(this);
  }

  _onClose() {
    const { onClose, closeCommonPopup } = this.props;
    closeCommonPopup();
    if (onClose) onClose();
  }

  async _onConfirm() {
    const { onConfirm, closeCommonPopup } = this.props;
    closeCommonPopup();
    if (onConfirm) await onConfirm();
  }

  _getImages = type => {
    if (type === 'ex') return exImages;
    if (type === 'wa') return waImages;
    return suImages;
  };

  render() {
    const {
      pageTitle,
      pageTitleString,
      title,
      clickableBg,
      onConfirm,
      needIntl,
      size,
      show,
      isProceeding,
      content,
      contentString,
      confirmText,
      confirmTextString,
      confirmTextColor,
      cancelText,
      cancelTextString,
      needHeader,
      imageType,
      isReverse,
      isBigPadding,
      child,
    } = this.props;
    const images = this._getImages(imageType);
    const cancelTxt = cancelTextString || <IntlMessages id={cancelText ? cancelText : 'button.close'} />;
    const confirmTxt = confirmTextString || <IntlMessages id={confirmText ? confirmText : 'button.confirm'} />;
    return (
      <Modal className={'common-popup-wrapper'} isOpen={show} toggle={clickableBg && this._onClose} size={size} centered={true}>
        {needHeader && (
          <ModalHeader
            toggle={this._onClose}
            close={
              <button className="close" onClick={this._onClose}>
                <CloseIcon />
              </button>
            }
          >
            {pageTitle || pageTitleString ? <div>{pageTitleString || <IntlMessages id={pageTitle} />}</div> : null}
          </ModalHeader>
        )}
        <ModalBody className={`common-popup-body ${isBigPadding && 'big-padding'}`}>
          {imageType && <img srcSet={`${images[1]} 2x, ${images[2]} 3x`} src={[images[0]]} alt="image" />}
          {title && <div className={'common-popup-title'}>{needIntl ? <IntlMessages id={title} /> : title}</div>}
          {content || contentString ? <div className={'common-popup-content'}>{contentString || <IntlMessages id={content} />}</div> : null}
          {child}
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={() => (isReverse ? this._onConfirm() : this._onClose())}
            disabled={isReverse && isProceeding}
            style={{ ...(isReverse && imageType === 'wa' && { color: '#f00' }), ...(isReverse && confirmTextColor && { color: confirmTextColor }) }}
          >
            {isReverse ? confirmTxt : cancelTxt}
          </Button>
          {onConfirm && (
            <Button
              onClick={() => (isReverse ? this._onClose() : this._onConfirm())}
              disabled={!isReverse && isProceeding}
              style={{ ...(!isReverse && imageType === 'wa' && { color: '#f00' }), ...(!isReverse && confirmTextColor && { color: confirmTextColor }) }}
            >
              {isReverse ? cancelTxt : confirmTxt}
            </Button>
          )}
        </ModalFooter>
      </Modal>
    );
  }
}

export default connect(null, { closeCommonPopup })(CommonPopup);
